<template>
  <v-container fluid>
    <v-row class="kahon text-center" align="center" justify="center">
      <v-col cols="12" sm="11" md="8" lg="10">
        <div class="text-h5 text-md-h4 text-justify white--text mb-3 font-weight-bold">
          <p>
            With KAHON.PH, we help you save space by storing your items for you.
            We keep your clutter, so you can live your life better. Get things
            done faster. Make life easier. Feel happier
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="11" md="8" lg="10">
        <p class="text-justify white--text">
          Unlike more traditional self-storage facilities, Kahon.ph’s end-to-end
          storage and safekeeping solution eliminates the need for you to leave
          the house or visit a warehouse. We pick up your things, pack them up,
          store and return them to you whenever you wish. You can create more
          space at home or at work anytime, without doing any of the heavy
          lifting.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "IdealSpace",

  data: () => ({}),
};
</script>
